const RowDisplayLocalization = (stringId) => {
  const lowest = '{{lowest}}';
  const highest = '{{highest}}';
  const total = '{{total}}';

  return ((t) => t(stringId, { lowest, highest, total }));
};

export default RowDisplayLocalization;
